<template>
  <line-chart style="position: relative; height:220px" :data="this.getLineChartData"
              :options="this.lineChartOptions" v-if="this.getLineChartData" class=""></line-chart>
</template>

<script>
  import LineChart from "../Wrappers/lineChart";
  import {salariesColors} from "../../../constants/constants";

  // risk
  //const ticks = ['high', 'medium', 'low', 'very low'];
  // engagement
  export default {
    name: "salariesLine",
    components: {LineChart},
    props: ['jobKeyword', 'currentSalary', 'yearsInCurrentPosition'],
    data() {
      return {
        // lineChartData: {},
        lineChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: 'top'
          },
          tooltips: {
            mode: 'index',
            callbacks: {
              title: (tooltipItem, chart) => {
                return `Years: ${tooltipItem[0].label}`;
              },
              label: (tooltipItem, chart) => {
                if (tooltipItem.datasetIndex === 1) {
                  if (tooltipItem.value === "NaN") {
                    return null;
                  }
                  let values = JSON.parse(tooltipItem.value)
                  return `Profile salary: ${Number(values[0]).toLocaleString('es-ES')} € - ${Number(values[1]).toLocaleString('es-ES')} €`;
                }
                return `Average salary: ${Number(tooltipItem.value).toLocaleString('es-ES')} €`;
              },
            },
          },
          scales: {
            xAxes: [{
              scaleLabel: {labelString: 'Years of experience', display: true},
              gridLines: {
                display: false
              },
            }],
            yAxes: [
              {
                scaleLabel: {labelString: `Salary for ${this.getTitle()}`},
                position: 'left',
                gridLines: {
                  display: false
                },
                ticks: {
                  suggestedMin: 12000,
                  callback: (value, index, values) => {
                    return `${Number(value).toLocaleString('es-ES')} €`;
                  }
                }
              }]
          },
        }
      }
    },
    computed: {
      getLineChartData() {
        let datasets = [];
        let labels = [];
        if (this.jobKeyword && this.jobKeyword.salaries) {
          labels = Array.from(Array(11).keys());
          datasets.push({
            label: `Salary for ${this.getTitle()}`,
            lineTension: 0.4,
            fill: false,
            backgroundColor: salariesColors[0].colorFill,
            borderColor: salariesColors[0].colorLine,
            data: this.jobKeyword.salaries
          });
          if (this.currentSalary) {
            let currentSalaryData = Array(11);
            // let currentSalaryDataMin = Array(11);
            // let currentSalaryDataMax = Array(11);
            // currentSalaryDataMin[this.yearsInCurrentPosition] = this.currentSalary.baseSalaryRange.min;
            // currentSalaryDataMin[this.yearsInCurrentPosition+1] = this.currentSalary.baseSalaryRange.min;
            // currentSalaryDataMax[this.yearsInCurrentPosition] = this.currentSalary.baseSalaryRange.max;
            // currentSalaryDataMax[this.yearsInCurrentPosition+1] = this.currentSalary.baseSalaryRange.max;
            currentSalaryData[this.yearsInCurrentPosition] = [
              this.currentSalary.baseSalaryRange.min,
              this.currentSalary.baseSalaryRange.max !== null ? this.currentSalary.baseSalaryRange.max : this.currentSalary.baseSalaryRange.min * 1.5
            ]
            // datasets.push({
            //   label: 'Min base salary range',
            //   lineTension: 0.4,
            //   fill: false,
            //   backgroundColor: salariesColors[1].colorFill,
            //   borderColor: salariesColors[1].colorLine,
            //   data: currentSalaryDataMin,
            // })
            // datasets.push({
            //   label: 'Max base salary range',
            //   lineTension: 0.4,
            //   fill: "-1",
            //   backgroundColor: salariesColors[1].colorFill,
            //   borderColor: salariesColors[1].colorLine,
            //   data: currentSalaryDataMax,
            // })
            datasets.push({
              type: 'bar',
              label: 'Salary range',
              lineTension: 0.4,
              // fill: "-1",
              backgroundColor: salariesColors[2].colorFill,
              borderColor: salariesColors[2].colorLine,
              borderWidth: 1,
              data: currentSalaryData,

            })
          }
        }
        return {labels, datasets};
      }
    },
    methods: {
      getTitle(){
        return this.jobKeyword && this.jobKeyword.name && this.jobKeyword.city ?
          `${this.jobKeyword.name} ${this.jobKeyword.city}` : '';
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/salariesLine.vue